import { createContext, useContext } from 'react';
export const NavVerticalContext = createContext(undefined);
export const useNavVerticalContext = () => {
    const context = useContext(NavVerticalContext);
    if (context === undefined) {
        throw new Error('useNavVerticalContext must be used within a NavVerticalProvider');
    }
    return context;
};
//# sourceMappingURL=NavVerticalContext.js.map